import { token } from "@/styled-system/tokens";
const textDark = token.var("colors.text.neutral");
const textLight = token.var("colors.gray.400");
const borderLight = token.var("colors.border.muted");
const borderDark = token.var("colors.gray.400");
token.var("fonts.ui");
const seriesColors = [token.var("colors.blue.600"), token.var("colors.blue.700"), token.var("colors.blue.900"), token.var("colors.blue.200"), token.var("colors.blue.100")];
const defaultSeriesColor = token.var("colors.blue.700");
export {
  borderDark,
  borderLight,
  defaultSeriesColor,
  seriesColors,
  textDark,
  textLight
};
